import styled from 'styled-components';
import { spacing } from '_utils/props';
import {
  svg,
  heading_m,
  heading_s,
  text_s,
  buttonAsLinkReset,
  linkWithoutVisited,
  safeFocusRemoval,
  focusOutline,
  mq,
  hideOnPrint,
  iconColorOnPrint
} from '_utils/styles';
import Grid from '_utils/components/Corporate/Grid';
import { Primary as PrimaryContainer } from '../TwoColumn/StyledTwoColumn';
import { Rule } from '_components/Corporate/Divider/StyledDivider';
import color from '_utils/styles/color';

export const Container = styled.article`
    & + & {
      margin-top: 20px; // spacing added by <Divider />
      &::before{
        margin: 0;
        ${({ theme }) => spacing({ theme, $my: 7 })}
        box-shadow: inset 0px -1px 0px ${({ theme }) => theme.colors.all.deepBlueTint15};
        content:"";
        height:1px;
        display: block;
      }
    }
    @media print {
        page-break-inside: avoid;
    }
  `;

export const Heading = styled.h2`
  ${heading_m}
  line-height: 1;
  ${({ theme }) => spacing({ theme, $mt: 0, $mb: 3 })};
`;

export const List = styled(Grid.Row)`
  list-style: none;
  padding: 0;

  /* force single column layout when in the lhs of
       a 2-col layout when less than desktop */
  ${PrimaryContainer} & {
    ${mq.lessThan('lg')} {
      li {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
    li {
      @media print {
        display: block;
      }
    }
  }
`;

export const Divider = styled(Rule)``;

export const FeatureListItem = styled(Grid.Item)`
  display: block;

  &.is-hidden {
    display: none;
  }

  ${hideOnPrint}
`;

export const ShowMoreItem = styled(Grid.Item)`
  ${hideOnPrint}
`;

export const FeatureTitle = styled.h3`
  ${heading_s}
  margin: 0;
  padding-left: 32px;
  margin-bottom: 4px;
`;

export const FeatureDescription = styled.p`
  ${text_s}
  margin-top: 4px;
  padding-left: 32px;
  margin-bottom: 0;
  & + & {
    margin-top: 16px;
  }
  color: ${({ theme }) => theme.colors.element.quaternary};
`;

export const FeatureIconPosition = styled.span`
  display: block;
  width: 0;
  height: 0;
  position: relative;
`;

export const FeatureIconContainer = styled.span`
  position: absolute;
  left: 0;
  top: 0px;
  width: 24px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mq('md')} {
    top: 2px;
  }
`;

export const FeatureTickWrapper = styled.span`
  ${svg(16, 12)}
  width: 14px;
  flex: none;
  path {
    fill: ${({ theme }) => theme.colors.featureList.tick};
  }
`;

export const FeatureCrossWrapper = styled.span`
  ${svg(14, 14)}
  width: 12px;
  flex: none;
  path {
    fill: ${({ theme }) => theme.colors.featureList.cross};
  }
`;

export const ShowMore = styled.button`
  ${buttonAsLinkReset}
  ${linkWithoutVisited}
    &:focus {
    ${safeFocusRemoval}
    ${focusOutline}
  }
  ${text_s}
  padding-right: 4px;
  margin: 0;
`;

export const ArrowWrapper = styled.span`
  ${svg(7, 12)}
  margin-left: 8px;
  width: 7px;
  transform: rotate(90deg);

  ${ShowMore}:focus &,
  ${ShowMore}:hover & {
    path {
      fill: ${({ theme }) => theme.colors.element.white};
      ${iconColorOnPrint}
    }
  }

  path {
    fill: ${({ theme }) => theme.colors.element.primary};
  }
`;
